import { ROUTE } from './routes';

export const PAGE_KEYS = {
  DASHBOARD: 'dashboard',
  COMMANDS: 'commands',
  AUTOMODE: 'automode',
  CHAOS: 'chaos',
  CHAOS_WIDGET: 'chaos-widget',
  GIVEAWAY: 'giveaway',
  GIVEAWAY_EMBED: 'giveaway-embed',
  VIEWERS: 'viewers',
  PROFILE: 'profile',
  USERS: 'users'
};

export const DASHBOARD_PAGE_ROUTE_PAIRS = [
  { page: PAGE_KEYS.DASHBOARD, route: ROUTE.DASHBOARD.MAIN },
  { page: PAGE_KEYS.COMMANDS, route: ROUTE.DASHBOARD.COMMANDS },
  { page: PAGE_KEYS.AUTOMODE, route: ROUTE.DASHBOARD.AUTOMODE },
  { page: PAGE_KEYS.CHAOS, route: ROUTE.DASHBOARD.CHAOS },
  { page: PAGE_KEYS.CHAOS_WIDGET, route: ROUTE.DASHBOARD.CHAOS_WIDGET },
  { page: PAGE_KEYS.GIVEAWAY, route: ROUTE.DASHBOARD.GIVEAWAY },
  { page: PAGE_KEYS.GIVEAWAY_EMBED, route: ROUTE.DASHBOARD.GIVEAWAY_EMBED },
  { page: PAGE_KEYS.VIEWERS, route: ROUTE.DASHBOARD.VIEWERS },
  { page: PAGE_KEYS.PROFILE, route: ROUTE.DASHBOARD.PROFILE },
  { page: PAGE_KEYS.USERS, route: ROUTE.DASHBOARD.USERS }
];
